import { render, staticRenderFns } from "./category-explorer.vue?vue&type=template&id=2a7e1794&"
import script from "./category-explorer.vue?vue&type=script&lang=js&"
export * from "./category-explorer.vue?vue&type=script&lang=js&"
import style0 from "./category-explorer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports